<script>

import config from '../../common/genericPanelConf';
import Service from '../../services/stock-management';
import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';
import GenericDataTable from '../../components/generic/GenericDataTable.vue';
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'

import GenericBooleanDropdown from '../../components/generic/GenericBooleanDropdown.vue'
import GenericCustomMasterDataAutocompleteV2 from '../../components/generic/GenericCustomMasterDataAutocompleteV2.vue';
import GenericCustomAutocompleteV2 from '../../components/generic/GenericCustomAutocompleteV2.vue';

export default {
    props: ['category', 'name'],
    components: {
        GenericDataTable, ResponsiveButton, GenericBooleanDropdown, GenericCustomMasterDataAutocompleteV2, GenericCustomAutocompleteV2
    },
    data(){
        return{
            editItem: {},
            configurationAutomatic: {},
            configurationManual: {},
            configurationManualLock: {},
            filters: {
                referenceDate: Utils.formatDatePlusDays(new Date(),-1),
                plantCode: null
            },
            twentyFour: '24.00',
            showProvenance: false,
            addManualVisible: false,
            excludedTanksVisible: false,
            addExcludedTankVisible: false,
            excludedTanks: [],
            excludedTanksLoading: false,
            addTankExcluded: {}
        }
    },
    created(){
        this.configurationAutomatic = {...config.getConfiguration(this.name)};
        this.configurationAutomatic.api = 'stock-management/monthly';
        this.configurationAutomatic.enableUpdate = false;
        this.configurationAutomatic.enableDelete = false;
        this.configurationAutomatic.enableInsert = false;

        this.configurationManual = {...config.getConfiguration(this.name)};
        this.configurationManual.api = 'stock-management/monthly-manual';

        this.configurationManual.customActions = [
            {
                name: 'stockManagementDailyTankDeleteButton',
                title: 'btn.delete',
                visible: false,
                cssClass: 'p-button-sm p-button-rounded p-button-warning mr-2',
                icon: 'pi pi-trash',
                data: {},
                fields: [],
                action: function (data, caller) {
                    caller.$emit('onStockManagementDailyTankDelete', data);
                }
            }
        ];

        this.configurationManualLock = {...config.getConfiguration('StockManagementDailyTankManualLocked')};
        this.configurationManualLock.api = 'stock-management/monthly-manual-and-locked';
        this.configurationManualLock.enableUpdate = false;
        this.configurationManualLock.enableDelete = false;
        this.configurationManualLock.enableInsert = false;

        if(this.configurationAutomatic){
            this.$store.dispatch('security/setNavbarTitle', 'StockManagementMonthlyTank.page_title');
        }
    },
    mounted(){
        
    },
    methods: {
        load(){
            this.loadAutomatic();
            this.loadManual();
            this.loadManualLocked();
        },
        loadAutomatic(){
            let d = Utils.formatDateForAPI(Utils.setFirstDayOfMonth(this.filters.referenceDate));
            let filters = {
                referenceDate: d,
                plant: this.filters.plantCode
            }
            this.$refs.automaticGrid.filterFromView(filters, true);
        },
        loadManual(){
            let d = Utils.formatDateForAPI(Utils.setFirstDayOfMonth(this.filters.referenceDate));
            let filters = {
                referenceDate: d,
                plant: this.filters.plantCode
            }
            this.$refs.manualGrid.filterFromView(filters, true);
        },
        loadManualLocked(){
            let d = Utils.formatDateForAPI(Utils.setFirstDayOfMonth(this.filters.referenceDate));
            let filters = {
                referenceDate: d,
                plant: this.filters.plantCode
            }
            this.$refs.manualLockedGrid.filterFromView(filters, true);
        },
        toggleProvenance(){
            this.showProvenance = this.showProvenance ? false: true;
        },
        onDialogEditSave(item, originalItem){
            for(const key in item){
                if(key + 'Source' in item){

                    if(item[key] != originalItem[key]){
                        item[key + 'Source'] = 'Manual';
                    }
                }
            }

            
            this.$store.dispatch("generic/setLoading", true);
            Service.saveStockManagementDailyTank(item, (response) => {
                
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.$refs.manualGrid.hideDialogEdit();
                    this.loadManual();
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })

        },
        showAddManual(visible){
            if(visible){
                this.editItem = {
                    referenceDate : this.filters.referenceDate,
                    type: 'Manual'
                };
            }
            this.addManualVisible = visible
        },
        onAddManual(){
            this.editItem.referenceDate =  Utils.formatDateForAPI(Utils.formatDatePlusDays(this.filters.referenceDate, 1))
            for(const key in this.editItem){
                if(key + 'Source' in this.editItem){
                    this.editItem[key + 'Source'] = 'Manual';
                }
            }
            this.$store.dispatch("generic/setLoading", true);
            Service.createStockManagementDailyTank(this.editItem, (response) => {
                
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.showAddManual(false);
                    this.loadManual();
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })

        },
        onStockManagementDailyTankDelete(item){
            this.$confirm.require({
                message: this.$t('messages.delete_message_question'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    this.$store.dispatch("generic/setLoading", true);
                    Service.deleteStockManagementDailyTank(item.id, response => {
                            this.$store.dispatch("generic/setLoading", false);
                            if(response.success){
                                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.delete_message_success'), life: 3000});
                                this.loadManual();
                            }else{
                                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                            }
                        })
                },
                reject: () => {
                    //callback to execute when user rejects the action
                }
            });
        },
        calculateStockManagement(){
            this.$confirm.require({
                message: this.$t('StockManagementDailyTank.calculateMessage'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {

                    let filters = {type: 'Monthly', referenceDate: Utils.formatDateForAPI(Utils.setFirstDayOfMonth(this.filters.referenceDate))};
                    filters.tankCodes = [];
                    let d = this.$refs.manualGrid.data;
                    if(d != null && d.length > 0){
                        filters.tankCodes = d.map(function(item) {
                            return item['tankcode'];
                        });
                    }

                    this.$store.dispatch("generic/setLoading", true);
                    Service.calculateStockManagementDailyTank(filters, response => {
                            this.$store.dispatch("generic/setLoading", false);
                            if(response.success){
                                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.operation_message_success'), life: 3000});
                                this.loadManual();
                            }else{
                                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                            }
                        })
                },
                reject: () => {
                    //callback to execute when user rejects the action
                }
            });
        },
        reimport(){

            this.$confirm.require({
                message: this.$t('StockManagementDailyTank.reimportMessage'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {

                    let params = {
                        creationDate: Utils.formatDateForAPI(Utils.setFirstDayOfMonth(this.filters.referenceDate)),
                        tank: true,
                        pipe: false
                    };

                    this.$store.dispatch("generic/setLoading", true);
                    Service.calculateNewMonth(params, response => {
                            this.$store.dispatch("generic/setLoading", false);
                            if(response.success){
                                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.operation_message_success'), life: 3000});
                                this.load();
                            }else{
                                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                            }
                        })
                },
                reject: () => {
                    //callback to execute when user rejects the action
                }
            });
        },
        showExcludedTanks(){
            this.excludedTanks= [];
            this.excludedTanksVisible = true;
            this.excludedTanksLoading = true;
            this.loadExcludedTanks();
        },
        loadExcludedTanks(){
            Service.getExcludedTanks((response) => {
                this.excludedTanksLoading = false;
                if(response.success){
                    this.excludedTanks = response.data;
                }
            })
        },
        onAddExcludedTank(){
            this.addTankExcluded = {};
            this.addExcludedTankVisible = true;
        },
        onDeleteExcludedTank(elem){
            this.$confirm.require({
                message: this.$t('messages.delete_message_question'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    Service.deleteExcludedTanks(elem.id, response => {
                        if(response.success){
                            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.delete_message_success'), life: 3000});
                            this.loadExcludedTanks();
                        }else{
                            this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                    })
                },
                reject: () => {
                    //callback to execute when user rejects the action
                }
            });
        },
        onAddTankExcluded(){
             Service.createExcludedTank(this.addTankExcluded, response => {
                if(response.success){
                    this.addExcludedTankVisible = false;
                    this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.delete_message_success'), life: 3000});
                    this.loadExcludedTanks();
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        exportStock(){

            this.$confirm.require({
                message: this.$t('messages.exportMessage'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    let d = Utils.formatDateForAPI(Utils.setFirstDayOfMonth(this.filters.referenceDate));

                    let plants = this.filters.plantCode ? [this.filters.plantCode] : ['ISABSUD', 'ISABNORD'];

                    plants.forEach((plant) => {
                        let filters = {
                            refDate: d,
                            plant: plant
                        }
                        Service.exportStockMonthly(filters, response => {
                            if(response.success){
                                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.exportSuccess'), life: 3000});
                            }else{
                                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                            }
                        });
                    });
                },
                reject: () => {
                    //callback to execute when user rejects the action
                }
            });
        }
    },
    computed: {
        conf(){
            return config;
        },
        constants(){
            return CommonConstants;
        },
        utils(){
            return Utils;
        },
        uiPermissions(){
            return this.$store.getters['security/uiPermissions'];
        },
        fieldsForDialogEdit(){
            let fields =  [];

            if(this.configurationManual && this.configurationManual.columns){
                fields = this.configurationManual.columns.filter(col => col.inLineEdit)
            }
            return fields;
        },
    }
}
</script>

<style >

</style>

<template>
    <!-- EDIT MODE DIALOG -->
    <Dialog v-model:visible="addManualVisible" :style="{width: '85vw'}" :modal="true" >
        <div class="grid">
            <div class="col-12 lg:col-4" v-for="field in fieldsForDialogEdit" :key="field.name">
                <label :for="field.name">{{$t(field.label)}}</label>
                <InputText 
                    :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                    v-if="field.type == 'string'" 
                    class="w-full"
                    v-model="editItem[field.name]" />
                <InputText 
                    :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                    class="w-full" 
                    type="number" 
                    v-if="field.type == 'number'"
                    v-model="editItem[field.name]" />
                <InputNumber
                    :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                    class="w-full" 
                    mode="decimal" :maxFractionDigits="field.digits"
                    v-if="field.type == 'decimal'"
                    v-model="editItem[field.name]" />
                <Calendar 
                    :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                    class="w-full" 
                    v-if="field.type == 'date'"    
                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                    :dateFormat="constants.DATE_FORMAT_POINT"
                    :showTime="field.onlyDate ? false : true"
                    v-model="editItem[field.name]" />
                <GenericBooleanDropdown
                    :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                    v-if="field.type == 'boolean'"
                    v-model="editItem[field.name]" 
                    class="w-full" />
                <GenericCustomMasterDataAutocompleteV2
                    :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                    v-if="field.type == 'select'"
                    :name="field.name"
                    v-model="editItem[field.updateField ?? field.name]" 
                    :api="field.selectApi"
                    :format="field.selectFormat" />
                <GenericCustomAutocompleteV2
                    class="w-full"
                    :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                    v-if="field.type == 'select-simple'"
                    :name="field.name"
                    v-model="editItem[field.updateField ?? field.name]" 
                    :api="field.selectApi"
                    :format="field.selectFormat" />
                <Textarea
                    :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                    class="w-full" 
                    v-if="field.type == 'textarea'"
                    v-model="editItem[field.name]" />
            </div>
        </div>
            <template #footer>
            <Button :label="$t('btn.save')" icon="pi pi-save" @click="onAddManual" autofocus />
        </template>
    </Dialog>

    <Dialog v-model:visible="addExcludedTankVisible" :modal="true" >
        <div class="grid">
            <div class="col-12" >
                <label :for="'tankcode'">{{$t('StockManagementDailyTank.tankcode')}}</label>
                
                <GenericCustomAutocompleteV2
                    class="w-full"
                    :name="tankcode"
                    v-model="addTankExcluded.tankCode" 
                    :api="'masterdata/equipment-combo?type=SERB'"
                    :format="{ label: 'label', value: 'label' }" />
            </div>
        </div>
            <template #footer>
            <Button :label="$t('btn.save')" icon="pi pi-save" @click="onAddTankExcluded" autofocus />
        </template>
    </Dialog>

    <Dialog v-model:visible="excludedTanksVisible" :modal="true" >
        <Button :label="$t('btn.add')" icon="pi pi-plus" class="p-button-sm p-button-success mr-2" @click="onAddExcludedTank" v-if="uiPermissions('stockManagementExcludedTankButtons').isEnabled" />
        <DataTable :value="excludedTanks" tableStyle="min-width: 50rem" :loading="excludedTanksLoading">
            <Column :exportable="false" v-if="uiPermissions('stockManagementExcludedTankButtons').isEnabled">
                <template #body="slotProps">
                    <Button icon="pi pi-trash" class="p-button-sm p-button-rounded p-button-warning mr-2" v-tooltip="$t('btn.delete')" @click="onDeleteExcludedTank(slotProps.data)" size="small" />
                </template>
            </Column>
            <Column field="tankCode" :header="$t('StockManagementDailyTank.tankcode')"></Column>
        </DataTable>
    </Dialog>
    
    <div class="grid">
        <div class="col-10 lg:col-2 field">
            <label for="referenceDate">{{$t('StockManagementDailyTank.referenceDate')}}</label>
            <Calendar
            view="month" dateFormat="mm/yy"
                :class="{'p-inputtext-sm w-full': true}"
                :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                :showTime="false"
                v-model="filters.referenceDate"
                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
        </div>
         <div class="col-2 lg:col-2 field">
            <label for="plant">{{$t('registryPlant.fk')}}</label>
            <Dropdown id="plant" v-model="filters.plantCode" :options="[{value: null, label: ''}, {value: 'ISABSUD', label: 'ISAB SUD'}, {value: 'ISABNORD', label: 'ISAB NORD'}]" optionLabel="label" optionValue="value" class="w-full" />
        </div>
        <div class="col-12 lg:col-7">
                <div class="p-3">
                    <ResponsiveButton :label="$t('btn.load')" icon="pi pi-replay" class="mx-1 my-1" @click="load"/>   
                    <ResponsiveButton :label="$t('StockManagementDailyTank.btn.loadprovenance')" icon="pi pi-exclamation-triangle" class="mx-1 my-1" @click="toggleProvenance"/>   
                    <span v-if="showProvenance">
                        <Chip class="p-2 m-1 mr-1 pi-col-bg" style="min-width:50px; ">
                            <span style="margin: 0 auto;">PI</span>
                        </Chip>
                        <Chip class="p-2 m-1 mr-1 sim-col-bg" style="min-width:50px; ">
                            <span style="margin: 0 auto;">SIM</span>
                        </Chip>
                        <Chip class="p-2 m-1 mr-1 lims-col-bg" style="min-width:50px; ">
                            <span style="margin: 0 auto;">LIMS</span>
                        </Chip>
                        <Chip class="p-2 m-1 mr-1 manual-col-bg" style="min-width:50px; ">
                            <span style="margin: 0 auto;">MANUAL</span>
                        </Chip>
                        <Chip class="p-2 m-1 mr-1 web-col-bg" style="min-width:50px; ">
                            <span style="margin: 0 auto;">WEB</span>
                        </Chip>
                        <Chip class="p-2 m-1 mr-1 mts-col-bg" style="min-width:50px; ">
                            <span style="margin: 0 auto;">MTS</span>
                        </Chip>

                    </span>
                    <ResponsiveButton :label="$t('btn.reimport')" icon="pi pi-download" class="mx-1 my-1" @click="reimport" :disabled="!uiPermissions('stockManagementDailyTankReimport').isEnabled"/>
                    <ResponsiveButton :label="$t('StockManagementDailyTank.btn.calculate')" icon="pi pi-calculator" class="mx-1 my-1" @click="calculateStockManagement()" :disabled="!uiPermissions('stockManagementDailyTankCalculateButton').isEnabled"/>   
                    <ResponsiveButton :label="$t('StockManagementDailyTank.btn.tanksExcluded')" icon="pi pi-download" class="mx-1 my-1" @click="showExcludedTanks" :disabled="!uiPermissions('stockManagementDailyTanksExcluded').isEnabled"/>
                    <ResponsiveButton :label="$t('btn.stockExport')" icon="pi pi-upload" class="mx-1 my-1" @click="exportStock" :disabled="!uiPermissions('stockManagementDailyTankCalculateButton').isEnabled"/>
                </div>
            </div>
        <div class="col-12" style="height: calc(80vh)">
             <TabView >
                <TabPanel :header="$t('StockManagementDailyTank.autoTab')">
                    <div class="col-12" style="height: calc(75vh)">
                        <GenericDataTable :configuration="configurationAutomatic" :category="'stock-management'" :name="'tank-automatic'" ref="automaticGrid"/>
                    </div>
                </TabPanel>
                <TabPanel :header="$t('StockManagementDailyTank.manualTab')">
                    <div class="col-12" style="height: calc(75vh)">
                    <ResponsiveButton :label="$t('btn.add')" icon="pi pi-plus" class="mx-1 my-1" @click="showAddManual(true)" :disabled="!uiPermissions('stockManagementDailyTankInsertButton').isEnabled"/>   
                    <ResponsiveButton :label="$t('StockManagementDailyTank.btn.calculate')" icon="pi pi-calculator" class="mx-1 my-1" @click="calculateStockManagement()" :disabled="!uiPermissions('stockManagementDailyTankCalculateButton').isEnabled"/>   

                        <GenericDataTable :configuration="configurationManual" :category="'stock-management'" :name="'tank-manual'" ref="manualGrid" :onDialogEditSave="onDialogEditSave" @on-stock-management-daily-tank-delete="onStockManagementDailyTankDelete"/>
                    </div>
                </TabPanel>
                <TabPanel :header="$t('StockManagementDailyTank.manualLockTab')">
                    <div class="col-12" style="height: calc(75vh)">
                        <GenericDataTable :configuration="configurationManualLock" :category="'stock-management'" :name="'tank-manual-locked'" ref="manualLockedGrid"/>
                    </div>
                </TabPanel>
            </TabView>
        </div>
    </div>
</template>